import React, { useEffect, useState } from 'react'
import Page from '../../../../component/Page'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import TitlePage from '../../../../component/TitlePage'
import { Box, Button, Checkbox, FormControl, FormControlLabel, Menu, MenuItem, Pagination, Select, Skeleton } from '@mui/material'
import InputSearch from '../../../../component/InputSearch'
import { getBranchList, getBudgetYearsList, getDepartmentsList, getMaterialsList, getMaterialsStock } from '../../services/api'
export default function MaterialsBalanceList() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    let id = searchParams.get('id') || ''
    let q = searchParams.get('q') || ''
    let b = searchParams.get('b') || 'all'
    let m = searchParams.get('m') || 'all'
    let ms = searchParams.get('ms') || 'all'
    let d = searchParams.get('d') || 'all'
    let sum = searchParams.get('sum') || ''
    let page = searchParams.get('page') || '1'
    const [data, setData] = useState([])
    const [rowsPerPage] = useState(10);
    const { profile } = useSelector(state => state.profile)
    const [branchs, setBranchs] = useState([])
    const [budgetYears, setBudgetYears] = useState([])
    const [departments, setDepartments] = useState([])
    const [materials, setMaterials] = useState([])
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [item, setItem] = useState()

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);

    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    useEffect(() => {
        const getBranch = async () => {
            const data = await getBranchList()
            setBranchs(data)
        }
        const getDepartments = async () => {
            const data = await getDepartmentsList()
            setDepartments(data)
        }
        const getBudgetYears = async () => {
            const data = await getBudgetYearsList()
            setBudgetYears(data)
        }
        const getMaterials = async () => {
            const data = await getMaterialsList()
            setMaterials(data)
        }
        getMaterials()
        getBranch()
        getDepartments()
        getBudgetYears()
    }, [])
    useEffect(() => {
        const getList = async () => {
            setLoading(true)
            const data = await getMaterialsStock(q, b, d, sum, m, ms, page, rowsPerPage)
            setData(data)
            setLoading(false)
        }
        getList()
    }, [q, b, d, page, sum, m, ms, rowsPerPage])
    return (
        <Page>
            <TitlePage title='รายการวัสดุคงคลัง' action={
                <>
                    {/* <AddButton link={'/materials/materials-expenses/add'} /> */}
                    <div class="col-lg-2 col-md-6 d-flex align-items-center justify-content-center">
                        <FormControlLabel control={<Checkbox checked={sum === 'true' ? true : false} onChange={e => setSearchParams({ sum: e.target.checked, q: q, b: b, m: m, ms: ms, d: d })} />} label="รวมรายการวัสดุ" />
                    </div>
                    {
                        profile?.BranchNo?.BranchNo === '00' &&
                        <Box className="col-lg-2 col-md-12 ">
                            <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                                <FormControl variant="standard" fullWidth >
                                    <Select value={b || ''}
                                        onChange={e => setSearchParams({ sum: sum, q: q, b: e.target.value, m: m, ms: ms, d: d })}
                                        disableUnderline
                                        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                    >
                                        <MenuItem value='all'>ศูนย์ทั้งหมด</MenuItem>
                                        {branchs?.map((x, i) => (
                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box >
                    }
                    <Box className="col-lg-2 col-md-12 ">
                        <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={d || ''}
                                    onChange={e => setSearchParams({ sum: sum, q: q, b: b, m: m, ms: ms, d: e.target.value })}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>กลุ่ม/ฝ่ายทั้งหมด</MenuItem>
                                    {departments?.map((x, i) => (
                                        <MenuItem value={x?.DepartmentName}>{x?.DepartmentName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box >
                    {/* <Box className="col-lg-2 col-md-12 ">
                        <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={y || ''}
                                    onChange={e => setSearchParams({ q: q, b: b, y: e.target.value, d: d })}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>ปีทั้งหมด</MenuItem>
                                    {budgetYears?.map((x, i) => (
                                        <MenuItem value={x?.BudgetYear}>{x?.BudgetYear}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box > */}
                    <Box className="col-lg-2 col-md-12 ">
                        <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={m || ''}
                                    onChange={e => setSearchParams({ sum: sum, q: q, b: b, m: e.target.value, ms: ms, d: d })}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>วัสดุทั้งหมด</MenuItem>
                                    {materials?.map((x, i) => (
                                        <MenuItem value={x?.ItemNo}>{x?.ItemName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box >
                    <Box className="col-lg-2 col-md-12 ">
                        <Box className='backgroundField' sx={{ marginRight: '20px' }}>
                            <FormControl variant="standard" fullWidth >
                                <Select value={ms || ''}
                                    onChange={e => setSearchParams({ sum: sum, q: q, b: b, m: m, ms: e.target.value, d: d })}
                                    disableUnderline
                                    MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
                                >
                                    <MenuItem value='all'>สถานะทั้งหมด</MenuItem>
                                    <MenuItem value='พร้อมใช้งาน'>พร้อมใช้งาน</MenuItem>
                                    <MenuItem value='ชำรุด-รอซ่อม'>ชำรุด-รอซ่อม</MenuItem>
                                    <MenuItem value='ชำรุด-ตัดบัญชี'>ชำรุด-ตัดบัญชี</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                    </Box >
                    <InputSearch value={q} onChange={e => setSearchParams({ sum: sum, q: e.target.value, b: b, m: m, ms: ms, d: d })} placeholder={"ค้นหา เลขที่ครุภัณฑ์"} />
                </>
            } />
            <div class="receive-list row">
                {loading ? <Skeleton variant="rounded" sx={{ width: '100%', height: '70vh' }} /> :

                    <div class="col-md-12 table-responsive-sm pb-3">
                        <table class="table table-borderless table-hover ">
                            <thead>
                                <tr>
                                    <th class="text-center">ที่</th>
                                    <th class="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                    <th class="text-center">หน่วยงาน</th>
                                    <th class="text-center">รายการ</th>
                                    {sum !== 'true' && <><th class="text-center">ปีงบประมาณ</th>
                                        {/* <th class="text-center">ประเภทเงิน</th> */}
                                        <th class="text-center">เลขครุภัณฑ์</th></>}
                                    <th class="text-center">ปริมาณ</th>
                                    <th class="text-center">ให้ยืม</th>
                                    <th class="text-center">ขอยืม</th>
                                    <th class="text-center">สถานะ</th>
                                    <th class="text-center"></th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {data?.items?.map((x, i) => (
                                    <tr className={id === x?.DocumentNo ? 'active' : ''}>
                                        <td class="text-center">{(data?.meta?.currentPage - 1) * data?.meta?.itemsPerPage + 1 + i}</td>
                                        <td class="text-center">{x?.BranchName}</td>
                                        <td class="text-center">{x?.DepartmentName}</td>
                                        <td class="text-center">{x?.ItemName}{x?.Size ? " " + x?.Size : ''} </td>
                                        {sum !== 'true' && <>
                                            <td class="text-center">{x?.BudgetYear}</td>
                                            {/* <td class="text-center">{x?.BudgetType}</td> */}
                                            <td class="text-center">{x?.Lot ? x?.Lot : '-'}</td></>}
                                        <td class="text-center">
                                            {x?.Balance?.toLocaleString()}
                                        </td>
                                        <td class="text-center">
                                            {x?.Lend?.toLocaleString()}
                                        </td>
                                        <td class="text-center">
                                            {x?.Borrowed?.toLocaleString()}
                                        </td>
                                        <td class="text-center">
                                            {x?.Status}
                                        </td>
                                        <td class="text-center">
                                            <td class="text-center">
                                                <Button onClick={(e) => {
                                                    handleClick(e)
                                                    setItem(x)
                                                }} variant='contained' sx={{ background: '#fbbe66', ':hover': { background: '#eda844' } }}>ดำเนินการ</Button>

                                            </td>
                                        </td>
                                    </tr >
                                ))}

                            </tbody >
                        </table >
                    </div >}
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                    PaperProps={{
                        style: {
                            width: 220,
                        },
                    }}
                >

                    <MenuItem onClick={() => { navigate('/materials/materials-receive/add', { state: item }) }}>รับวัสดุ</MenuItem>
                    {/* <MenuItem onClick={() => { navigate('/materials/materials-expenses/add', { state: item }) }}>จ่าย / ยืม / ซ่อม</MenuItem>
                    <MenuItem onClick={() => { navigate('/materials/materials-transfers/add', { state: item }) }}>โอนวัสดุ</MenuItem>
                    <MenuItem onClick={() => { navigate('/materials/materials-returns/add', { state: item }) }}>คืนวัสดุ</MenuItem>
                    <MenuItem onClick={() => { navigate('/materials-debit/add', { state: item }) }}>ตัดบัญชี</MenuItem> */}
                </Menu>
                <div class="col-md-12 text-center mt-4">
                    <Pagination sx={{ display: 'flex', justifyContent: 'center' }} color="primary" count={data?.meta?.totalPages} page={+page} onChange={(event, value) => setSearchParams({ page: value, id: id, sum: sum, q: q, b: b, m: m, ms: ms, d: d })} shape="rounded" />
                </div>
            </div >
        </Page>
    )
}
